import { QueryObserverOptions, useQuery } from 'react-query';

import { useDlVaultContract } from 'clients/contracts/hooks';
import FunctionKey from 'constants/functionKey';

import getNetworkRewardDetails, { GetNetworkRewardDetailsInput, GetNetworkRewardDetailsOutput } from '.';

type TrimmedGetNetworkRewardDetailsInput = Omit<GetNetworkRewardDetailsInput, 'dlVaultContract'>;

export type UseGetNetworkRewardDetailsQueryKey = [
  FunctionKey.GET_NETWORK_REWARD_DETAILS,
  TrimmedGetNetworkRewardDetailsInput,
];

type Options = QueryObserverOptions<
  GetNetworkRewardDetailsOutput,
  Error,
  GetNetworkRewardDetailsOutput,
  GetNetworkRewardDetailsOutput,
  UseGetNetworkRewardDetailsQueryKey
>;

const useGetNetworkRewardDetails = (input: TrimmedGetNetworkRewardDetailsInput, options?: Options) => {
  const dlVaultContract = useDlVaultContract();

  return useQuery(
    [FunctionKey.GET_NETWORK_REWARD_DETAILS, input],
    () => getNetworkRewardDetails({ dlVaultContract, ...input }),
    options,
  );
};

export default useGetNetworkRewardDetails; 